import React, { Component } from "react";
import fileDownload from "js-file-download";

//Actions
import { getUserByBranch } from "../../UserList/UserListAction";
import { getWhatsappLoanRequestListAction, updateWhatsappLoanRequestAction } from "../WhatsappAction";
import { dowloadedAction } from "../../../constants/Action";

//Constants
import { OPERATION_STATUS } from "../../../config/axios.init";
import { USER_ROLES } from "../../../constants/appConstants";

//Utility
import Utility from "../../../utils/Utility";

//String
import { Strings } from "../../../resources/i18n/i18n";
import LoadingModal from "../../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../../CustomUIComponents/UserNotification/UserNotification";
import withHOC from "../../../HOC/HOC";
import WhatsappInterest from "./WhatsappInterest";

class WhatsappInterestContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            showLoadingModal: false,
            toShowToast: false,
            toastMessage: "",
            toastLevel: "",
        };
    }

    componentDidMount() {
        this.getUserList(USER_ROLES.salesPerson);
    }

    getUserList = (role, branchId = "") => {
        let users = [];
        const request = {
            role: role,
            branchId: branchId,
        };
        this.setState({ showLoadingModal: true });
        getUserByBranch(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                response.data.data.forEach((object) => {
                    object.us.forEach((user) => {
                        user.value = user.userId;
                        let count = users.reduce(function (n, val) {
                            return n + (val.name === user.name);
                        }, 0);
                        if (count === 0) users.push(user);
                    });
                });

                this.setState({
                    users,
                    showLoadingModal: false,
                });
            } else {
                this.setState({
                    errorMessage: response.error.message,
                    showLoadingModal: false,
                });
            }
        });
    };

    handleOnClickWhatsappLoanRequest = (searchFilterObject) => {
        this.setState({
            showLoadingModal: true,
        });

        getWhatsappLoanRequestListAction(searchFilterObject, (responsedata) => {
            if (responsedata.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    numberOfPages: responsedata.data.data.nop,
                    rows: responsedata.data.data.lr,
                    errorMessage: "",
                    showLoadingModal: false,
                });
            } else {
                this.setState({
                    errorMessage: responsedata.error.message,
                    rows: [],
                    showLoadingModal: false,
                });
            }
        });
    };

    updateWhatsappLoanRequest = (reqObj, callBack) => {
        this.setState({
            showLoadingModal: true,
            errorMessage: "",
            isSuccess: false,
        });

        updateWhatsappLoanRequestAction(reqObj, (responseData) => {
            if (responseData.status === OPERATION_STATUS.SUCCESS) {
                this.setState(
                    {
                        isSuccess: true,
                        successMessage: reqObj.rt === "ASSIGNED"
                            ? Strings("salesPersonAssignedSuccess")
                            : Strings("deletedSuccessfully"),
                        level: "success",
                        showLoadingModal: false,
                        errorMessage: "",
                    },
                    () => {
                        callBack(true);
                    }
                );
            } else {
                this.setState(
                    {
                        isSuccess: true,
                        successMessage: responseData.error.message,
                        level: "error",
                        errorMessage: responseData.error.message,
                        showLoadingModal: false,
                    },
                    () => {
                        callBack(true);
                    }
                );
            }
        })
    }

    /**
     * Downloads the WhatsApp interest report for the current filters (status, etc.)
     * @param {string} url download url with fileType query param
     * @param {object} requestData search filters mirroring the list request
     * @param {string} fileType PDF | CSV
     * @param {boolean} isDownloadFile false when the range exceeds 7 days and the
     *   backend emails the report instead of streaming a file
     */
    downloadReports = (url, requestData, fileType, isDownloadFile) => {
        this.setState({
            showLoadingModal: true,
            toShowToast: false,
            toastMessage: "",
            toastLevel: "",
        });
        dowloadedAction(
            url,
            requestData,
            (response) => {
                if (response.status === OPERATION_STATUS.SUCCESS) {
                    if (!isDownloadFile) {
                        // Range > 7 days: the backend emailed the report.
                        this.setState({
                            showLoadingModal: false,
                            toShowToast: true,
                            toastMessage: Strings("pdfDownload"),
                            toastLevel: "success",
                        });
                    } else if (Utility.checkBlobTypeForFileDownload(response.data.type)) {
                        fileDownload(
                            response.data,
                            Strings("WHATSAPP_INTEREST_REPORT") +
                            "-" +
                            Utility.getReportFormattedDateString(
                                Utility.convertDateIntoMiliSeconds(new Date())
                            ) +
                            Utility.getFileType(fileType)
                        );
                        this.setState({ showLoadingModal: false });
                    } else {
                        this.setState({
                            showLoadingModal: false,
                            toShowToast: true,
                            toastMessage: Strings("NoRecordsFound"),
                            toastLevel: "error",
                        });
                    }
                } else {
                    this.setState({
                        showLoadingModal: false,
                        toShowToast: true,
                        toastMessage: response.error.message,
                        toastLevel: "error",
                    });
                }
            },
            "WhatsappInterestReport",
            isDownloadFile
        );
    };

    render() {
        return (
            <>
            <LoadingModal showLoadingModal={this.state.showLoadingModal} />
            {this.state.toShowToast && (
                <UserNotification
                    key={this.state.toastMessage}
                    userNotificationObj={{
                        message: Strings(this.state.toastMessage),
                        level: this.state.toastLevel,
                    }}
                />
            )}
            {this.state.isSuccess && (
                <UserNotification
                    key='Success'
                    userNotificationObj={{
                        message: Strings(this.state.successMessage),
                        level: this.state.level,
                    }}
                />
            )}
            <WhatsappInterest
                    userList={this.state.users}
                    handleOnClickSearchFilter={this.handleOnClickWhatsappLoanRequest}
                    rows={this.state.rows}
                    loggedInUser={this.props.loggedInUser}
                    //update salesperson to loan request
                    updateLoanRequest={this.updateWhatsappLoanRequest}
                    //download report
                    downloadReports={this.downloadReports}
                    //Pagination
                    numberOfPages={this.state.numberOfPages}
            />
            </>
        )
    }
}

const WhatsappInterestWrapper = withHOC(WhatsappInterestContainer);

export default WhatsappInterestWrapper;